import { createRoot } from '@wordpress/element';
import domReady from '@wordpress/dom-ready';
import Notice from '@admin-notice/components/notice';

domReady( () => {
	const noticeRoot = document.getElementById( 'suremails-admin-notice' );
	if ( noticeRoot ) {
		const root = createRoot( noticeRoot );
		root.render( <Notice /> );
	}
} );
